var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9989 20.65C11.483 20.65 11.0417 20.4663 10.675 20.0989C10.3083 19.7315 10.125 19.2898 10.125 18.7739C10.125 18.258 10.3087 17.8167 10.6761 17.45C11.0435 17.0833 11.4852 16.9 12.0011 16.9C12.517 16.9 12.9583 17.0837 13.325 17.4511C13.6917 17.8185 13.875 18.2602 13.875 18.7761C13.875 19.292 13.6913 19.7333 13.3239 20.1C12.9565 20.4667 12.5148 20.65 11.9989 20.65ZM10.15 14.95V3.22501H13.85V14.95H10.15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.36d4ae91b46296c68657b17bf9dfb954.svg";
export { ForwardRef as ReactComponent };